import React, { useEffect, useState } from "react";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface ShelterOccupancyPercentageMetricState {
  data: any;
}

export const ShelterOccupancyPercentageMetric = ({ data }: ShelterOccupancyPercentageMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [percent, setPercent] = useState<string>();

  useEffect(() => {
    if (data) {
      const { occupancy } = data;
      const occupied = occupancy?.filter((item: any) => item.occupant_id !== null).length;
      const percentage = ((occupied / occupancy?.length) * 100).toFixed(1);
      setPercent(percentage?.toString());
    }
    setIsLoading(false);
  }, [data]);

  return <SingleCardMetric title={"Occupancy %"} total={percent} isLoading={isLoading} />;
};
